import { DiContainerInjectFn } from '@@/di/ts';
import { SimpleMixingService } from '@@/mixing/services/simple-mixing.service';
import { AnalyticsMixingService } from '@@/mixing/services/analytics-mixing.service';
import { RecipeMixingService } from './services/recipe-mixing.service';
import { LogisticMixingService } from './services/logistics-mixing.service';

export default ((container) => {
  container.bind(SimpleMixingService).to(SimpleMixingService).inSingletonScope();
  container.bind(AnalyticsMixingService).to(AnalyticsMixingService).inSingletonScope();
  container.bind(RecipeMixingService).to(RecipeMixingService).inSingletonScope();
  container.bind(LogisticMixingService).to(LogisticMixingService).inSingletonScope();
}) as DiContainerInjectFn;
